import { useSyncExternalStore } from "react";
import { pageKeyHints } from "./key-hints.ts";

/**
 * Whether a key may be named, for a React surface that words something by it (`key-hints.ts`): the surface draws again the
 * moment a keyboard is first in use or the page stops being a touch page, so its accessible text never waits for another
 * render to catch up.
 *
 * @returns True when keys may be named.
 * @example
 * const keyed = useKeyHints();
 */
export function useKeyHints(): boolean {
  return useSyncExternalStore(pageKeyHints.subscribe, pageKeyHints.getSnapshot, pageKeyHints.getSnapshot);
}
